import {
  buildContractTermsSummary,
  type PaymentScheduleSide,
  type PaymentScheduleTranche,
} from '@metycle/shared';

export interface ContractTerms {
  readonly label: string | null;
  readonly triggerLine: string | null;
}

// Renders the ticket's seeded payment terms into the editor's reference box.
// `label` reuses the shared contract-terms summary; `triggerLine` is the
// editor-specific headline (the BL-tranche milestone, not the downpayment
// anchor) e.g. "Trigger: ETA at PoD • Offset: 7 days • Timing: Before".
export function contractTermsFromSchedule(side: PaymentScheduleSide | null): ContractTerms {
  if (side === null || side.tranches.length === 0) return { label: null, triggerLine: null };
  const triggerTranche =
    side.tranches.find((t) => t.kind === 'BLTranche' && t.trigger_event !== null) ??
    side.tranches.find((t) => t.trigger_event !== null);
  return { label: buildContractTermsSummary(side), triggerLine: buildTriggerLine(triggerTranche) };
}

function buildTriggerLine(tranche: PaymentScheduleTranche | undefined): string | null {
  const event = tranche?.trigger_event ?? null;
  if (event === null) return null;
  const parts = [`Trigger: ${event.replace(/_/g, ' ')}`];
  const offset = tranche?.offset_days ?? null;
  if (offset !== null) parts.push(`Offset: ${offset} days`);
  const timing = tranche?.trigger_timing ?? null;
  if (timing !== null) parts.push(`Timing: ${timing}`);
  return parts.join(' • ');
}
